import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { UnsavedChangesService } from './unsaved-changes.service';

/**
 * Fragt vor dem Verlassen einer Ansicht nach, wenn dort etwas Ungespeichertes steht.
 *
 * Gehört an jede Detailroute, deren Komponente sich über `watchUnsavedWork`
 * anmeldet. Wo sich nichts anmeldet, lässt der Wächter wortlos durch — er kann
 * also gefahrlos an allen Detailrouten stehen.
 *
 * Wichtig: Angular ruft den Wächter auch, wenn sich nur die `:id` ändert (die
 * Route wird dann nicht neu aufgebaut, aber `paramsChange` gilt als Wechsel).
 * Genau das ist der häufigste Fall — der Sprung von einem Datensatz zum nächsten
 * über die Liste daneben.
 */
export const unsavedChangesGuard: CanDeactivateFn<unknown> = () =>
  inject(UnsavedChangesService).confirm();
